<template>
  <div class="min-h-screen ">
    <header class=" sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-center items-center h-16">
          <div class="flex items-center">
            <router-link to="/" class="flex items-center">
              <img src="/TelidooPay_logo.svg" alt="TelidooPay" class="h-8 w-auto" />
            </router-link>
          </div>
          
        </div>
      </div>
    </header>

    <main class="flex-1">
      <router-view />
    </main>


    <!-- Activity Monitor -->
    <ActivityMonitor v-if="showActivityMonitor" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ActivityMonitor from '@/components/ActivityMonitor.vue'

const route = useRoute()

const showActivityMonitor = computed(() => 
  route.name === 'legal-entity' || route.name === 'physical-person'
)
</script>
